import { getEnv } from "./utils";

const USER = "user";
const SECOND = 1000;
const MINUTE = SECOND * 60;
const TOKEN_TTL = MINUTE * 19;
const IDLE_TIMEOUT_MIN = MINUTE * 10;
const PASSWORD_STRENGTH = {
  MIN_LENGTH: 8,
  MIN_UPPERCASE: 1,
  MIN_LOWERCASE: 1,
  MIN_SPECIALCHARACTER: 1,
  MIN_NUMERIC: 1,
};
const EMAIL_PLACEHOLDER = "Enter an email address";
const VERIFICATION_CODE_PLACEHOLDER = "123456";
const PASSWORD_PLACEHOLDER = "********";
const FIRSTNAME_PLACEHOLDER = "Enter first name";
const LASTNAME_PLACEHOLDER = "Enter last name";
const PHONE_PLACEHOLDER = "Enter phone number";
const CUSTOMER_LIST_QUERY_KEY = "customerListQuery";
const LOCATION_PATHNAME_KEY = "locationPathName";
const ACCOUNTS_TAB_QUERY_KEY = "accountsTabQuery";
const INVITES_TAB_QUERY_KEY = "invitesTabQuery";
const INVALID_VALUE = "Invalid value";
const ENV_MAPPER = {
  development: "dev",
  staging: "staging",
  test: "test",
  uat: "uat",
  qa: "qa",
  production: "v3",
  connect: "connect",
  local: "local",
  integration: "intg",
};
export const NDC_CONNECT_ENDPOINT =
  getEnv() === ENV_MAPPER.connect ? "ndc-connect-auth" : "ndc-connect";

const AUTH_TOKEN =
  getEnv() !== ENV_MAPPER.connect ? "authToken" : "ssoToken";

const ACCESS_TOKEN = "accessToken";
const ACCESS_TOKEN_REFRESH = "accessTokenRefresh";
const WORKFLOW_TYPE = "/flows/automation/sync/onboarding";
const WORKFLOW_TYPE_ASYNC = "/flows/automation/async/onboarding";
const APP_PERMISSION_MAPPER: any = {
  account: "app.account.view",
  workbench: "app.workbench.view",
  admin: "nf.app.platform.view",
  inventory: "app.inventory.view",
  userEdit: "users.self.manage",
  airlineManage: "nf.airlines.manage",
  distributorManage: "nf.distributors.manage",
  contentServiceView: "nf.content.services.view",
  agencyManage: "nf.agencies.manage",
  agencyView: "agencies.view",
  subscriptionManage: "nf.agencies.subscriptions.manage",
  subscriptionView: "agencies.subscriptions.view",
  userManage: "users.manage",
  userView: "users.view",
  transactionManage: "travel.transactions.manage",
  transactionView: "travel.transactions.view",
  transactionSetupManage: "travel.transactions.setup.manage",
};

const REFRESH_TOKEN = "refreshToken";
const PUBLISH_SETUP_FORMAT = [
  {
    label: "TRAACS Wave",
    value: 1,
    code: "TRAACS",
  },
  {
    label: "NUTRAACS",
    value: 2,
    code: "NUTRAACS",
  },
];

const STR_GDS = [
  {
    label: "Airline",
    value: "Airline",
  },
  {
    label: "Nuflights",
    value: "Nuflights",
  },
];
const SELECTED_ORGANIZATION = "selectedOrganization";

// Base URL (without query params) of the agency signup page, used to build
// invitation links. Keyed by the same short codes `getEnv()` returns.
const AGENCY_SIGNUP_BASE_URL_BY_ENV: any = {
  [ENV_MAPPER.development]: "https://platform.dev.nuflights.com/agencySignup",
  [ENV_MAPPER.staging]:
    "https://platform.staging.llc.nuflights.com/agencySignup",
  [ENV_MAPPER.production]: "https://platform.v3.nuflights.com/agencySignup",
};

const AGENCY_SIGNUP_BASE_URL =
  AGENCY_SIGNUP_BASE_URL_BY_ENV[getEnv()] ??
  AGENCY_SIGNUP_BASE_URL_BY_ENV[ENV_MAPPER.development];

export {
  USER,
  AUTH_TOKEN,
  ACCESS_TOKEN,
  ACCESS_TOKEN_REFRESH,
  TOKEN_TTL,
  IDLE_TIMEOUT_MIN,
  PASSWORD_STRENGTH,
  EMAIL_PLACEHOLDER,
  VERIFICATION_CODE_PLACEHOLDER,
  PASSWORD_PLACEHOLDER,
  FIRSTNAME_PLACEHOLDER,
  LASTNAME_PLACEHOLDER,
  PHONE_PLACEHOLDER,
  ENV_MAPPER,
  APP_PERMISSION_MAPPER,
  REFRESH_TOKEN,
  PUBLISH_SETUP_FORMAT,
  CUSTOMER_LIST_QUERY_KEY,
  LOCATION_PATHNAME_KEY,
  ACCOUNTS_TAB_QUERY_KEY,
  INVITES_TAB_QUERY_KEY,
  INVALID_VALUE,
  STR_GDS,
  SELECTED_ORGANIZATION,
  WORKFLOW_TYPE,
  WORKFLOW_TYPE_ASYNC,
  AGENCY_SIGNUP_BASE_URL,
};
